// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  facebook: {
    version: 'v3.2',
    appId: '234914370193088',
    appSecret: 'eb7a8ea5c8b3e3a7e0334a3a1bd5ca3c',
    endpoint: '/kaewkwanpetshop',
    appToken: '234914370193088|6l7eVCuZ0bEiEmbPRs5c15zqDOY',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
